<div class="container-fluid">
<div *ngIf="loading" class="row" style="text-align: center">
    <div class="col-12 text-align-left">
      <h2>
        <b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b>
      </h2>
    </div>
  </div>
<div *ngIf="!loading">
<form #companyForm="ngForm">
                  <div class="d-flex align-items-center">
        <mat-form-field class="example-full-width">
          <mat-label>Yearly Company Weight Goal</mat-label>
          <input
            matInput
            type="number"
            name="Yearlyvalue"
            [(ngModel)]="yearlyWeightGoal"
            required
          />
        </mat-form-field>
        <span class="ml-2">lbs</span>
      </div>

                  <div class="d-flex justify-content-end mt-3">
                    <button
                      type="button"
                      class="btn btn-success"
                      (click)="saveCompany()"
                      [disabled]="!companyForm.valid"
                    >
                      Save changes
                    </button>
                  </div>
                </form>
</div>
</div>